import React, { useState, useEffect } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
//import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';

//import { AiOutlineDownload } from 'react-icons/ai';
//import { BsTrash } from 'react-icons/bs';
//import axios from "axios";
//import { GoAlert } from "react-icons/go";
import { FiAlertTriangle } from "react-icons/fi";
import { FiAlertOctagon } from "react-icons/fi";

//const { download_docx_esterno } = require('../Funzioni_comuni')


const download_docx_esterno = (documento, progetto) => {
    const cognome = progetto.id_alunno.cognome
    const nome = progetto.id_alunno.nome
    let indirizzo
    if (documento === 'progetto') {
        indirizzo = 'Progetto_docx'
    }
    if (documento === 'rapporto') {
        indirizzo = 'Rapporto_docx'
    }
  
    console.log('indirizzo ' + indirizzo)
    

  };


const Lista_icone = (props) => {
//    const [somma, calcola_somma] = useState('');


    useEffect(() => {
    
    }, [props.classe_selezionata_item]);



    const Check_documenti_progetto = () => {
//        console.log(props.progetto.id_ditta)
        let data = null 
        let check_convenzione_approvata = false
        let check_sicurezza_approvata = false
        let check_formazione_A_approvata = false
        let check_formazione_B_approvata = false
        let check_formazione_C_approvata = false
        let livello_formazione_richiesto   
//        livello_formazione_richiesto = ((props.classe_selezionata_item.nome.includes('5')) ? 3)
        
  //      var c = ((1 < 2) ? 1 : 2);

        if (props.progetto.id_ditta != null && Array.isArray(props.progetto.id_ditta.documentazione_array)) {
            data = props.progetto.id_ditta.documentazione_array
            let result = data.find(o => o.tipologia_documento == "convenzione" && o.cestino == false )
            if (result != undefined) {
                check_convenzione_approvata = true
            
            }
            let result1 = data.find(o => o.tipologia_documento == "sicurezza" && o.cestino == false )
            if (result1 != undefined) {
                check_sicurezza_approvata = true
            
            }

        }
        if (props.progetto.id_alunno != null && Array.isArray(props.progetto.id_alunno.documentazione_array)) {
            data = props.progetto.id_alunno.documentazione_array
            let result2 = data.find(o => o.tipologia_documento == "formazione_A" && o.cestino == false )
            if (result2 != undefined) {
                check_formazione_A_approvata = true
            
            }
            let result3 = data.find(o => o.tipologia_documento == "formazione_B" && o.cestino == false )
            if (result3 != undefined) {
                check_formazione_B_approvata = true
            
            }
            let result4 = data.find(o => o.tipologia_documento == "formazione_C" && o.cestino == false )
            if (result4 != undefined) {
                check_formazione_C_approvata = true
            
            }

        }
     

        
//        console.log(props.classe_selezionata_item)
        return <>
        <div className="d-flex flex-row justify-content-between"  >
        <div className="d-flex flex-column">
            {props.progetto.stage_confermato_dalla_ditta == -2 && <div className="inline text-warning">  <FiAlertTriangle  size='2rem'/> Mail di Inizio stage non inviata </div>} 

        </div>
        <div className="d-flex flex-column">
       
        </div>
       
    </div> 
        <div className="d-flex flex-row justify-content-between"  >
            <div className="d-flex flex-column">
            {!check_convenzione_approvata && <div className="inline text-danger">  <FiAlertTriangle  size='2rem' /> Ditta: Manca il pdf della convenzione </div>} 
            {!check_sicurezza_approvata && <div className="inline  text-danger"> <FiAlertTriangle  size='2rem'/> Ditta: Manca il pdf della sicurezza </div>} 
            </div>
            <div className="d-flex flex-column">
            {/* toolmemo ingrandimento di un icona react icon*/}
            {!check_formazione_A_approvata && 
             !check_formazione_B_approvata &&
            <div className="inline text-danger"> Alunno: Manca pdf Formazione rischio basso  <FiAlertOctagon size='2rem' /> </div>} 
            {props.classe_selezionata_item != undefined && props.classe_selezionata_item.livello_formazione > 1 
             && !check_formazione_B_approvata 
             && !check_formazione_C_approvata 
             && <div className="inline text-danger"> Alunno: Manca pdf Formazione rischio medio <FiAlertOctagon  size='2rem'/> </div>} 
            {props.classe_selezionata_item != undefined && props.classe_selezionata_item.livello_formazione > 2 && !check_formazione_C_approvata && <div className="inline text-danger"> Alunno: Manca pdf Formazione rischio alto <FiAlertOctagon  size='2rem'/> </div>} 

            </div>
           
        </div>
        </>
    }


    function scarica () {
        
    }
    
    return (
        <>
            {Check_documenti_progetto()}
            {/*  
            <Button onClick={() => download_docx_esterno('progetto',props.progetto)}>
            <AiOutlineDownload />
            </Button>
                */}
        </>
    )
}
export default Lista_icone;